import { isUndefined } from 'lodash-es';
import * as t from 'io-ts';

import type { RichMultiSelectDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';
import { getAggregationsFromSpec } from './smartViewSetting';

export interface SmartViewValuesSettingDefinition extends RichMultiSelectDefinition {
    key: 'SMART_VIEW_VALUES';
}

const definition: SmartViewValuesSettingDefinition = {
    key: 'SMART_VIEW_VALUES',
    type: 'RichMultiSelect',
    label: 'Smart view values',
    value: [],
    options: [],
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.array(t.string));

export const codec = specSettingsInterface.input;

export const SmartViewValuesSettingDefinition = define({
    key: 'SMART_VIEW_VALUES',
    label: 'SmartViewValues',
    definition,
    fromSetting: settings => {
        if (isUndefined(settings.smartView)) return undefined;

        if (isUndefined(settings.smartViewValues)) return [];

        return specSettingsInterface.extractValue(settings.smartViewValues);
    },
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: (settings, spec) => {
        if (isUndefined(settings.smartView)) return undefined;
        const checkedAggregations = getAggregationsFromSpec(spec);

        const options = checkedAggregations
            .find(aggregation => aggregation.smartViewTag === settings.smartView)
            ?.items.map(item => ({
                key: item.key,
                label: settings.shortLabels ? item.shortLabel : item.label,
            }));
        return {
            ...definition,
            ...specSettingsInterface.createDefinitionWithSettings(settings.smartViewValues),
            options: options || [],
        };
    },

    applySettingDependency: ({ diff, settings, specification }) => {
        const smartViewChanged = !!diff.SMART_VIEW;

        if (!smartViewChanged || isUndefined(settings.SMART_VIEW)) return undefined;

        const checkedAggregations = getAggregationsFromSpec(specification);

        const aggregation = checkedAggregations.find(
            aggregation => aggregation.smartViewTag === settings.SMART_VIEW,
        );

        // if there are no default values specified, select all
        const value = aggregation
            ? aggregation.defaultAggregationItems || aggregation.items.map(item => item.key)
            : undefined;

        return {
            value,
        };
    },
});
